import { jsx as _jsx } from "react/jsx-runtime";
import { AccentText } from '../../atoms/accent-text/accent-text';
import { Text } from '../../atoms/text/text';
export const Label = ({ bold, children, isAccentText, renderAs = 'label', size, ...props })=>{
    return isAccentText ? /*#__PURE__*/ _jsx(AccentText, {
        renderAs: renderAs,
        size: size,
        ...props,
        children: children
    }) : /*#__PURE__*/ _jsx(Text, {
        bold: bold,
        renderAs: renderAs,
        size: size,
        ...props,
        children: children
    });
};

//# sourceMappingURL=label.js.map